<template>
  <div id="app">
    <Main/>
    <particles-bg  type="circle"  :bg="true"/>
  </div>
</template>

<script>
import Main from "./components/Main";
import { ParticlesBg } from "particles-bg-vue";
export default {
  name: "App",
  components: {
    Main,
    ParticlesBg
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
<style>
@tailwind preflight;
@tailwind components;
@tailwind utilities;
</style>
